import { PlanRulesTemplate } from "planning-portal-library/src/lib/core/domain/models/plan-rules-template";
import { PlanRulesTemplateWebEntity } from "./plan-rules-template-web-entity";
import { Mapper } from "planning-portal-library/src/lib/core/base";

export class PlanRulesTemplateWebRepositoryMapper extends Mapper<
  PlanRulesTemplateWebEntity,
  PlanRulesTemplate
> {
     mapFrom(param: PlanRulesTemplateWebEntity): PlanRulesTemplate {
        return {
            id: param.id,
            planId: param.planId,
            connectionId: param.connectionId,
            includeSnapIn: param.includeSnapIn,
            microSegmantSize: param.microSegmantSize,
            serviceFrequency: param.serviceFrequency,
            serviceTime: param.serviceTime,
            snapInDistance: param.snapInDistance,
            snapInSpeed: param.snapInSpeed,
            speedOverride: param.speedOverride,
            startLocationLatitude: param.startLocationLatitude,
            startLocationLongitude: param.startLocationLongitude,
            endLocationLatitude: param.endLocationLatitude,
            endLocationLongitude: param.endLocationLongitude,
            targetJobDuration: param.targetJobDuration,
            targetSegmantDuration: param.targetSegmantDuration,
            vehicleProfile: param.vehicleProfile,
            description : param.description,
            endLocationAddress : param.endLocationAddress,
            startLocationAddress : param.startLocationAddress,
        }
    }
     mapTo(param: PlanRulesTemplate): PlanRulesTemplateWebEntity {
         return {
            id: param.id,
            planId: param.planId,
            connectionId: param.connectionId,
            includeSnapIn: param.includeSnapIn,
            microSegmantSize: param.microSegmantSize,
            serviceFrequency: param.serviceFrequency,
            serviceTime: param.serviceTime,
            snapInDistance: param.snapInDistance,
            snapInSpeed: param.snapInSpeed,
            speedOverride: param.speedOverride,
            startLocationLatitude: param.startLocationLatitude,
            startLocationLongitude: param.startLocationLongitude,
            endLocationLatitude: param.endLocationLatitude,
            endLocationLongitude: param.endLocationLongitude,
            targetJobDuration: param.targetJobDuration,
            targetSegmantDuration: param.targetSegmantDuration,
            vehicleProfile: param.vehicleProfile,
            description : param.description,
            endLocationAddress : param.endLocationAddress,
            startLocationAddress : param.startLocationAddress,
        }
    }
}